import { Box, Typography } from '@mui/material';

export function AlphaBadge(): React.JSX.Element {
  return (
    <Box
      alignItems="center"
      bgcolor="#eaf0f8"
      border="1px solid #326ac2"
      borderRadius={2}
      display="flex"
      gap={0.5}
      paddingX={1}
      paddingY={0.5}
    >
      <Typography color="#326ac2" lineHeight="14px" variant="caption">
        Alpha
      </Typography>
    </Box>
  );
}
